export const DEFAULT_SCANNER_ZOOM = 2;

export function clampScannerZoom(zoom: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, zoom));
}

export function resolveInitialScannerZoom(
  storedZoom: string | null,
  min: number,
  max: number,
): number {
  const parsedZoom = storedZoom === null ? DEFAULT_SCANNER_ZOOM : Number(storedZoom);
  const requestedZoom = Number.isFinite(parsedZoom) ? parsedZoom : DEFAULT_SCANNER_ZOOM;
  return clampScannerZoom(requestedZoom, min, max);
}
